module.exports = __webpack_public_path__ + "img/5.cb3ed6dd.png";